import { instance } from "@/api/index";

export const loadTodo = () => instance.get("/back/todo");
export const createTodo = payload => instance.post("/back/todo", payload);
export const modiTodo = (id, payload) =>
  instance.put(`/back/todo/${id}`, payload);
export const delTodo = id => instance.delete(`/back/todo/${id}`);
